import { RiBarChartLine } from '@remixicon/react';

import {
  CREATE_CHART_BLOCK_TOOL,
  createToolExtension,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

export const CreateChartBlockToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-chart-block',
    predicate: tool => tool.endsWith(CREATE_CHART_BLOCK_TOOL),
    icon: RiBarChartLine,
    display: 'grouped',
    render: () => null,
    renderTool: () => null,
  }),
);
